import type { BlockViewProps as PloneBlockViewProps } from '@plone/types';
import { useSelector } from 'react-redux';
import { FormState } from '@fhnw/types/formState';
import clsx from 'clsx';
import SafeHtmlWithScripts from './SafeHtmlWithScripts';
import HtmlIframe from '@fhnw/components/HtmlIframe/HtmlIframe';

interface HTMLBlockViewProps extends PloneBlockViewProps {
  isEditMode?: boolean;
}

const HTMLBlockView = (props: HTMLBlockViewProps) => {
  const { data, style, className, isEditMode = false } = props;
  const token = useSelector<FormState, string>(
    (state) => state.userSession.token,
  );
  const htmlContent = data?.href?.[0]?.snippet ?? null;
  const useIframe = data?.iframe_view ?? false;

  // Iframe View
  if (useIframe && htmlContent) {
    return (
      <HtmlIframe content={htmlContent} className={className} style={style}>
        {isEditMode && <div className="html-block-overlay" />}
      </HtmlIframe>
    );
  }

  // Direct Render
  if (htmlContent) {
    return (
      <SafeHtmlWithScripts
        className={className}
        style={style}
        htmlContent={htmlContent}
      />
    );
  }

  // Placeholder when logged in
  if (token) {
    return (
      <div className={clsx('html-block-placeholder', className)} style={style}>
        Select an HTML snippet in the sidebar. <br /> The content will appear
        here after saving.
      </div>
    );
  }

  // Otherwise, return null
  return null;
};

export default HTMLBlockView;
